import { render } from "./CategoriasLoja.vue?vue&type=template&id=a0b5dfb8&scoped=true"
import script from "./CategoriasLoja.vue?vue&type=script&lang=js"
export * from "./CategoriasLoja.vue?vue&type=script&lang=js"

import "./CategoriasLoja.vue?vue&type=style&index=0&id=a0b5dfb8&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0b5dfb8"]])

export default __exports__